import React, { useState } from "react";

const ListView = ({ tasks, buckets, filters, onAddTask, onTaskClick, onTaskEdit, onTaskDelete }) => {
  const [newTaskName, setNewTaskName] = useState("");
  const [newTaskBucket, setNewTaskBucket] = useState("");

  const applyFilters = (task) => {
    if (filters?.priority && task.priority !== filters.priority) return false;
    if (filters?.bucket && task.bucket_id !== filters.bucket) return false;
    if (filters?.assignedTo && !task.assigned_users?.some((u) => u.id === filters.assignedTo)) return false;
    return true;
  };

  return (
    <div className="list-view">
      <table className="task-table">
        <thead>
          <tr>
            <th>Task title</th>
            <th>Assigned to</th>
            <th>Priority</th>
            <th>Due</th>
            <th>Bucket</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {/* Add Task Row */}
          <tr>
            <td colSpan="6">
              <select value={newTaskBucket} onChange={(e) => setNewTaskBucket(e.target.value)}>
                <option value="">Select Bucket</option>
                {buckets.map((b) => (
                  <option key={b.id} value={b.id}>{b.name}</option>
                ))}
              </select>
              <input
                type="text"
                placeholder="+ Add a task"
                value={newTaskName}
                onChange={(e) => setNewTaskName(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" && newTaskName.trim() && newTaskBucket) {
                    onAddTask(newTaskBucket); // trigger popup/form in board logic
                    setNewTaskName("");
                    setNewTaskBucket("");
                  }
                }}
                className="add-task-input"
              />
            </td>
          </tr>

          {/* Tasks */}
          {buckets.map((bucket) =>
            (tasks[bucket.id] || [])
              .filter(applyFilters)
              .map((task) => (
                <tr key={task.id} className="task-row" onClick={() => onTaskClick(task)}>
                  <td>{task.name}</td>
                  <td>
                    {task.assigned_users?.length ? (
                      task.assigned_users.map((u) => (
                        <img
                          key={u.id}
                          src={`https://teams.tidyds.com${u.profile_pic}`}
                          alt={u.name}
                          className="avatar"
                        />
                      ))
                    ) : (
                      <span>Unassigned</span>
                    )}
                  </td>
                  <td>
                    {task.priority === "high" && "❗"}
                    {task.priority === "medium" && "⬆"}
                    {task.priority === "low" && "⬇"}
                  </td>
                  <td>{task.due_date ? new Date(task.due_date).toLocaleDateString() : ""}</td>
                  <td>{bucket.name}</td>
                  <td>
                    <div className="task-actions">
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          onTaskEdit(task);
                        }}
                      >
                        ✏️
                      </button>
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          onTaskDelete(task);
                        }}
                      >
                        🗑️
                      </button>
                    </div>
                  </td>
                </tr>
              ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ListView;
